(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class MobileDisclosure extends DetailsDisclosure {
      constructor() {
        super();

        const collapseEnabled = this.dataset.collapse === 'true';
        if (!collapseEnabled) return;

        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.querySelectorAll('.disclosure, .disclosure__title, .disclosure__panel, .disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(`mobile-${cl}`);
            });
          });
        } else {
          this.toggle.removeAttribute('tabindex');
          this.querySelectorAll('.mobile-disclosure, .mobile-disclosure__title, .mobile-disclosure__panel, .mobile-disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('mobile-disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(cl.substr(7));
            });
          });
        }
      }
    }

    customElements.define('mobile-disclosure', MobileDisclosure);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["league-category-carousel"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('league-category-carousel')) {
  class LeagueCategoryCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.league-category-carousel__track');
      this.buttons = Array.from(this.querySelectorAll('[data-category-direction]'));
      this.onClick = (event) => {
        const button = event.target.closest('[data-category-direction]');
        if (!button || !this.contains(button)) return;
        const card = this.track.querySelector('.league-category-carousel__card');
        if (!card) return;
        const gap = parseFloat(getComputedStyle(this.track).gap) || 0;
        this.track.scrollBy({left: Number(button.dataset.categoryDirection) * (card.getBoundingClientRect().width + gap), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      };
      this.updateButtons = () => {
        const left = Math.abs(this.track.scrollLeft);
        const end = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        this.buttons.forEach(button => {button.disabled = Number(button.dataset.categoryDirection) < 0 ? left <= 2 : left >= end - 2;});
      };
      this.addEventListener('click', this.onClick);
      this.track.addEventListener('scroll', this.updateButtons, {passive:true});
      this.resizeObserver = new ResizeObserver(this.updateButtons);
      this.resizeObserver.observe(this.track);
      this.updateButtons();
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.track?.removeEventListener('scroll', this.updateButtons);
      this.resizeObserver?.disconnect();
    }
  }
  customElements.define('league-category-carousel', LeagueCategoryCarousel);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
